import request from '@/utils/request';

export function commonLog(type, params) {
  return request({
    url: '/Common/log',
    method: 'POST',
    data: {
      type,
      params,
    },
    silentRequest: true,
  });
}

export function getWechatConfig(url) {
  return request({
    url: '/Common/wechatConfig',
    params: {
      configUrl: url,
    },
    silentRequest: true,
  });
}

export function getCommonConfig() {
  return request({
    url: '/Common/getAppConfig',
  });
}

export function getStaticShareInfo(type) {
  return request({
    url: '/Common/getStaticShareInfo',
    params: {
      type,
    },
    silentRequest: true,
  });
}

export function getDefaultActivityPageInfo(type) {
  return request({
    url: '/Marketing/defaultActivityPageInfo',
    params: {
      type,
    },
    silentRequest: true,
  });
}

export function getEventLogConfig() {
  return request({
    url: '/Common/getEventLogConfig',
    silentRequest: true,
  });
}

export function getAppRouteMap() {
  return request({
    url: '/Common/getAppRouteMap',
    silentRequest: true,
  });
}

export function getCaptchaInfo() {
  return request({
    url: '/Common/captcha',
  });
}

export function getWeChatUserInfo(redirectTo) {
  return request({
    url: '/User/getInfoWeChatUrl',
    params: {
      redirectTo,
    },
    silentRequest: true,
  });
}

export function checkLogin() {
  return request({
    url: '/Marketing/checkLogin',
    silentRequest: true,
  });
}

export function loginRegisterWithMobile(data) {
  return request({
    url: '/User/loginRegisterWithMobile',
    method: 'POST',
    data,
  });
}

export function getCommonCouponPopupInfo(pageName) {
  return request({
    url: '/Common/couponPopupInfo',
    params: {
      pageName,
    },
  });
}
